import axios from 'axios'
import { errorNotifier } from './interceptors'

const httpSvc = axios.create()

httpSvc.interceptors.response.use(
  response => response,
  errorNotifier,
);

export default httpSvc
